import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Noticias.css';

const Noticias = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    fetch('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/noticias')
      .then(response => response.json())
      .then(data => {
        const sortedNews = data.sort((a, b) => b.timestamp - a.timestamp);
        setNews(sortedNews);
      });
  }, []);

  return (
    <div className='noticias-page'>
      <center><h1 className='botonbordeazul p-2'>Noticias</h1></center>
      <div className='noticias-list'>
        {news.map((item) => (
          <Link key={item.id} to={`/noti/${item.id}`} className='noticia-item'>
            <img src={item.imagenUrl} alt={item.titulo} className='noticia-thumb' />
            <div className='noticia-info'>
              <h2>{item.titulo}</h2>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Noticias;